import { CSSProperties } from 'react'

import { Box, BoxProps } from '@chakra-ui/react'
import { css } from '@emotion/react'

interface ButtonTagIProps extends BoxProps {
  onClick?: () => void
  children?: React.ReactNode
  style?: CSSProperties
}

export const ButtonTag = ({
  onClick,
  children,
  style,
  ...rest
}: ButtonTagIProps) => {
  return (
    <Box
      _hover={{
        backgroundColor: 'link.100',
        color: 'white',
      }}
      alignItems='center'
      as='button'
      backgroundColor='white'
      color='black'
      css={css`
        &:hover .icon path:not(:first-of-type) {
          stroke: white;
        }
      `}
      display='flex'
      flexDirection='row'
      fontSize='14px'
      fontWeight='semibold'
      justifyContent='flex-start'
      noOfLines={1}
      onClick={onClick}
      role='group'
      // Apply hover style to nested icons
      style={{
        marginRight: '0px',
        padding: '1px 7px 1px 7px',
        display: 'flex',
        border: '2px solid #BBB',
        borderRadius: '10px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}
